import styled from "styled-components/macro";

const QuestionSpacer = styled.div<{ size?: number }>`
  height: ${({ size }) => (size ? `${size}px` : "30px")};
`;

export default QuestionSpacer;
